// extracted by mini-css-extract-plugin
export default {"wrap":"wrap-YekZS","content":"content-kbwzv","error-img":"error-img-rtU9L","error-text":"error-text-bID4X","back-btn":"back-btn-fuYwo","maskfadein":"maskfadein-O1kIn"};